import React, { useEffect } from 'react';
import Customize from './customization';
import { useRecoilState } from 'recoil';
import { modelAtom } from '../../../state';
import { CLOUD_FRONT_URL } from '../../../aws.config';

const Customized = ({ category, productData }: { category: string, productData: any }) => {
    const [modelSrc, setModelSrc] = useRecoilState<{ categoryName: string, src: string, loading: number }>(modelAtom);
    const [selectedProduct, setSelectedProduct] = React.useState<number>(0);
    useEffect(() => {
        setModelSrc({
            categoryName: '',
            src: '',
            loading: 0
        })
        setSelectedProduct(0);
        if (productData?.styledGltfUrl) {
            switch (category) {
                case 'pillow':
                    setModelSrc({
                        ...modelSrc,
                        categoryName: category,
                        src: `${CLOUD_FRONT_URL}${productData?.styledGltfUrl}`
                    });
                    break;
                default:
                    setModelSrc({
                        ...modelSrc,
                        categoryName: category,
                        src: productData?.styledGltfUrl
                    });
                    break;
            }
        }
    }, [productData]);

    return (
        <>
            <Customize category={category} productData={productData} selectedProduct={selectedProduct} />
        </>
    );
};

export default Customized;